var __jsx = React.createElement;
import React from "react";
import CarSaleCardCarousel from "./CarSaleCardCarousel";
import bgImage from "../icons/bgMobile.svg";
import { CarSaleCardSkeleton } from "./CarSaleCardSkeleton";
var MobileHeroLayout = function MobileHeroLayout(_ref) {
  var data = _ref.data,
    isLoading = _ref.isLoading,
    sellTradeItems = _ref.sellTradeItems,
    autoPlay = _ref.autoPlay,
    autoPlayInterval = _ref.autoPlayInterval,
    onBookAppointment = _ref.onBookAppointment,
    onSlideChange = _ref.onSlideChange,
    onRefetch = _ref.onRefetch;
  return /*#__PURE__*/React.createElement("div", {
    id: "mobile-hero-layout",
    className: "md:hidden px-5 pt-3 pb-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "mobile-hero-background-container",
    className: "absolute inset-y-0 left-4 right-4 flex items-center justify-center overflow-hidden rounded-xl"
  }, /*#__PURE__*/React.createElement("img", {
    id: "mobile-hero-background-image",
    src: bgImage,
    loading: "lazy",
    alt: "Background",
    className: "w-full h-[600px] max-h-[700px] object-cover -translate-y-3"
  })), /*#__PURE__*/React.createElement("div", {
    id: "mobile-hero-content",
    className: "relative z-10 mx-auto pt-4 mt-[30px]"
  }, /*#__PURE__*/React.createElement("h1", {
    id: "mobile-hero-title",
    className: "text-primary-new text-[32px] font-bold text-center mb-4 pt-0"
  }, function () {
    var firstDotIndex = data.label1.indexOf(".");
    if (firstDotIndex === -1) {
      return data.label1;
    }
    var firstLine = data.label1.substring(0, firstDotIndex + 1);
    var secondLine = data.label1.substring(firstDotIndex + 1).trim();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      id: "mobile-hero-title-line-1",
      className: "block my-4"
    }, firstLine), /*#__PURE__*/React.createElement("span", {
      id: "mobile-hero-title-line-2"
    }, secondLine));
  }()), data.label2 && /*#__PURE__*/React.createElement("p", {
    id: "mobile-hero-subtitle",
    className: "text-gray-700 text-[20px] font-semibold text-center my-6"
  }, data.label2), isLoading && /*#__PURE__*/React.createElement(CarSaleCardSkeleton, null), !isLoading && sellTradeItems.length > 0 && /*#__PURE__*/React.createElement(CarSaleCardCarousel, {
    cards: sellTradeItems,
    autoPlay: autoPlay,
    autoPlayInterval: autoPlayInterval,
    onBookAppointment: onBookAppointment,
    onSlideChange: onSlideChange,
    onRefetch: onRefetch
  })));
};
export default MobileHeroLayout;